export default {
  1: "selezionato",
  2: "contattato",
  3: "approvato",
}
